<template>
  <b-modal class="cx_listEditor2" :class="{cx_modal_maximized: maximized}" v-model="show" :title="$translate(title)" @ok="onOk" :no-close-on-backdrop="true" centered :key="bindIndex" ref="modal" :html="html">   
      <button  slot="modal-header" type="button" aria-label="Close" class="maximize" v-if="$api.spMode == false" @click="onChangeDisplayMode"><i class="material-icons small valign">{{maximized ? 'filter_none' : 'check_box_outline_blank'}}</i></button>
      <div class="cx_list_dialog_outer">
      <!-- ヘッダスロット-->
      <div class="cx_list_dialog_header">
        <slot name="header" :editor="_self"></slot>
      </div>
      <!-- 行追加ボタンの配置 -->
      <div class="add_div"><slot name="buttons"></slot><Button class="button" v-if="showAdd" @click="onAddRow" caption="追加" icon="add_circle" /></div>
      <div class="cx_list_header"  v-if="captions && captions.length > 0" :style="gridStyle" ref="listHead">
        <table  :style="{'min-width' : totalWidth}">
          <colgroup>
            <col v-if="showRemove" width="40" />
            <col v-for="(width, col) in widths" :key="col" :width="width" />
          </colgroup>
          <thead>
            <tr>
              <th v-if="showRemove" >
                <div class="header_cell start">
                  
                </div>
              </th>
              <th v-for="(caption, col) in captions" :key="col" :data-item-id="col">
                <div class="header_cell" v-if="col == 0" :class="{'start' : showRemove == false,'center' : showRemove}">
                  {{ $translate(caption) }}
                </div>
                <div class="header_cell" :class="{'end' : col == captions.length -1,'center' : col != captions.length -1}" v-if="col != 0">
                  {{ $translate(caption) }}
                </div>
              </th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="cx_list_container"  v-if="captions && captions.length > 0" :style="gridStyle2" ref="listView"  @scroll="onScroll" >
        <table  :style="{'min-width' : totalWidth}" @keydown.up="moveFocus('up')" @keydown.down="moveFocus('down')" @keydown.left="moveFocus('left')" @keydown.right="moveFocus('right')">
          <colgroup>
            <col v-if="showRemove" width="40" />
            <col v-for="(width, col) in widths" :key="col" :width="width" />
          </colgroup>
          <tbody>
            <tr class="cx_margin_row"></tr>
            <tr v-for="(item, row) in items" :key="item.listDialog_rowKey ? item.listDialog_rowKey : row" :data-item-id="row" :class="{ rowHighlight: isActiveRow(row) }">
              <td class="remove_cell" v-if="showRemove" >
                <div class="remove_div">
                <!-- 行削除ボタンの配置 -->
                <b-link @click="onRemoveRow(row)" class="button_remove"><i class="material-icons small valign">remove_circle</i></b-link>
                </div>
              </td>
              <!-- Widthが効かないため、max-widthを指定 -->
              <!-- <td v-for="(caption, col) in captions" :key="col" :data-item-id="col" class="control_cell"> -->
              <td :id="row + '_' + col" v-for="(caption, col) in captions" :key="col" :data-item-id="col" class="control_cell" :style="{'max-width' : 0}" @focusin="setActive(row,col)">
                <!-- コントロール配置用スロット-->
                <slot :name="'col' + col" :item="item" :editor="_self" :row="row"></slot>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td :colspan="captions.length"></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <!-- フッタスロット-->
      <div class="cx_list_dialog_footer">
        <slot name="footer" :editor="_self"></slot> 
      </div>
    </div>  
      <!-- フッタにボタンスロットを追加-->
      <div v-if="!buttonNames" slot="modal-footer" class="cx_modal_footer_button_container">
        <slot name="footer_buttons"></slot>
      </div>
      <button v-if="!buttonNames" slot="modal-footer" type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeDialog" >キャンセル</button>        
      <button v-if="!buttonNames" slot="modal-footer" type="button" class="btn btn-primary" data-dismiss="modal" @click="onOk" >OK</button>          

    <!-- ワークフローアクション毎の複数ボタン対応 -->
    <button v-if="buttonNames" slot="modal-footer" type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeDialog" >キャンセル</button>
    <button v-for="(item, key) in buttonNames" :key="key" slot="modal-footer" type="button" :class="(buttonNames.length>1 && key==0) ? 'btn btn-info' : 'btn btn-primary'" @click="onCustomOK($event,key)" >{{item}}</button>
    <!-- <button v-if="buttonNames" slot="modal-footer" type="button" class="btn btn-primary" @click="onWorkflowAction(null)" >OK</button> -->
  </b-modal>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';

@Component
export default class ListDialog extends Vue implements Components.IEditor {
  @Prop({ default: '' }) public title: string; //タイトル
  @Prop({ default: '' }) public modelName: string;
  // @Prop({ default: ()=> new Array()}) public items: Array<any>;
  @Prop({ default: null }) public captions: Array<string>;
  @Prop({ default: null }) public widths: Array<number>;
  @Prop({ default: false }) public primitive: boolean;
  @Prop({ default: null }) public defaultValue: any;
  /**非同期実行ハンドラを指定すると完了まで待機します。 */
  @Prop({default:null}) public exec: (items:any[])=>Promise<boolean>;
  @Prop({default:true}) public showAdd:boolean;
  @Prop({default:true}) public showRemove:boolean;
  @Prop({ default: null }) public onCreate: (item: any) => Promise<any>;  
  @Prop({default:null}) public width:number;
  @Prop({default:null}) public height:number;
  @Prop({ default: null }) public buttonNames: Array<string>;
  @Prop({default:null}) public execWithIndex: (items:any[], index:number)=>Promise<boolean>;  
  //プリミティブの場合は匿名オブジェクトのvalueプロパティをバインドします。
  @Prop({default:null}) public html: string;
  @Prop({default: false}) public isRemainAfterExec: boolean;

    public activeRow:number = null;
    public activeCol:number = null;
    

    public moveFocus(direction:string){
      var xMove = 0;
      var yMove = 0;
      switch(direction){
        case "left":xMove=-1;break;
        case "right":xMove=1;break;
        case "up":yMove=-1;break;
        case "down":yMove=1;break;
        default : return;
      }

      let currentRow = this.activeRow
      let currentCol = this.activeCol;
      while(currentRow < this.items.length && currentRow >= 0 && currentCol < this.captions.length && currentCol >= 0)
      {
        currentRow += yMove;
        currentCol += xMove;

        var el = document.getElementById(currentRow + '_' + currentCol);
        const controlEl :HTMLElement= el?.querySelector('input');
        if(controlEl) {
          this.activeCol = currentCol;
          this.activeRow = currentRow;
          controlEl.focus();
          break;
        }
      }
    }

    public setActive(row:number,col:number){
      this.activeRow = row;
      this.activeCol = col;
    }

    public isActiveRow(num:number) {
      return num == this.activeRow;
    }
    public isActiveCell(row:number,col:number) {
      return col == this.activeCol && row == this.activeRow;
    }

  public items: Array<any> = new Array();
  public show: boolean = false; //リスト
  public showDialog() {
    this.activeRow = null;
    this.activeCol=null;
    this.listDialog_rowKey = 0;
    if(this.items)this.items.forEach(item => this.setRowKey(item));
    this.maximized = false;
    this.show = true;
  }
  public closeDialog() {
    this.show = false;
    this.$emit('closeDialog');
  }

  /**高さを設定します。 */
  public get gridStyle(): string {
    // return  this.width ? 'width:' + this.width +'px; max-width:unset;':'' ;
    if (this.$api.spMode || this.maximized) return  'max-width:unset;';    
    else return  this.width ? 'width:' + this.width +'px; max-width:unset;':'' ;
  }
  public get gridStyle2(): any {
    //  return (this.height ? 'height:' + this.height + 'px;overflow-y:auto;flex:none;':'') + (this.width ? 'width:' + this.width +'px; max-width:unset;':'' );
    if (this.$api.spMode) return (this.height ? 'height:' + this.height + 'px;overflow-y:auto;flex:none;':'') + 'max-width:unset;';
    else if (this.maximized) return 'max-width:unset;flex:1';
    else return (this.height ? 'height:' + this.height + 'px;overflow-y:auto;flex:none;':'') + (this.width ? 'width:' + this.width +'px; max-width:unset;':'' );
  }    
  public onScroll(event: any) {
    //ヘッダ側の水平スクロールを合わせる
    (this.$refs.listHead as HTMLElement).scrollTo((this.$refs.listView as HTMLElement).scrollLeft, 0);
  }
 @Watch('show')
 public onShowChanged(){
   if(this.show) this.bindIndex+=1;
 }
 public get totalWidth(){
   if (this.widths) {
     var total = 50;
     this.widths.forEach(value => total += value);
     if (this.width && total < this.width -2)total = this.width -2;
     return total + 'px';
   } else {
     return 50 + 'px';
   }
 }
  public bindIndex = 0;
  //IEditor実装
  public validator: Components.Validator = new Components.Validator();
  public controls: Components.IControl[] = new Array();

  public addControl(control: Components.IControl) {
    if (control.validator != null) {
      this.validator.Validators.push(control.validator);
    }
    control.isEdit = true; //編集状態を強制する
    this.controls.push(control);
  }
  public removeControl(control: Components.IControl){
    if (control.validator != null) {
      var index = this.validator.Validators.indexOf(control.validator);
      if (index != -1) this.validator.Validators.splice(index, 1);
    }    
    var index1 = this.controls.indexOf(control);
    if (index1 != -1) this.controls.splice(index1, 1);    
  }
  public onCustomOK(e:any, index:number){
    this.exeIndex = index;
    this.onOk(e);
  }
  exeIndex:number = null;
  // OKボタン
  public onOk(e: any) {
    if(this.captions && this.captions.length > 0 && this.items.length == 0) return;
    //バリデーションを実行する～どうやって?
    e.preventDefault();
    if (this.validator.validate()) {
      //呼び出しもとにイベント処理してもらう
      if (this.primitive) {
        let temp = new Array();
        this.items.forEach(obj => temp.push(obj.value));
        //this.$emit('ok', temp);
        this.onExec(temp);
      } else {
        // this.$emit('ok', this.items);
        this.onExec(this.items);
      }
    // } else {
    //   e.preventDefault();
    }
  }

  public onExec(items:any[]){
    this.$api.startWaitCusor();
    if (this.exec != null){
      //レスポンスが帰ってきたら閉じる

      this.exec(items).then(
        success => {
          this.$api.closeWaitCursor();
          if (this.isRemainAfterExec) this.show = true;
          else this.show = (success || success == undefined) ? false : true;
        }
        );
    } else if (this.execWithIndex != null){
      this.execWithIndex(items,this.exeIndex).then(
        success => {
          this.$api.closeWaitCursor();
          this.show = (success || success == undefined) ? false : true;
        }
        );
    
    } else {
        this.$emit('ok', items);
        this.show = false;      
        this.$api.closeWaitCursor();
    }
    
  }
  
  public listDialog_rowKey:number = 0;
  public setRowKey(item:any){
    item.listDialog_rowKey = 'rowKey_' + this.listDialog_rowKey++;
  }
  //行追加ボタン
  public onAddRow() {
    //配列に新規追加する
    var instance :any = null;
    if (this.primitive) instance = { value: this.defaultValue };
    else instance = this.$api.createInstance(this.modelName);
    this.setRowKey(instance);

    if (this.onCreate) this.onCreate(instance).then((obj)=>this.items.push(obj));
    else this.items.push(instance);

  }

  // 行削除ボタン
  public onRemoveRow(index: number) {
    //これじゃダメな気がするけど
    this.items.splice(index, 1);
  }
  //行追加～外部からの追加
  public onAddItem(item:any){
    this.setRowKey(item);
    this.items.push(item);
  }

  //ダイアログ最大化サポート
  public maximized : boolean = false;
  public onChangeDisplayMode(){
    this.maximized = !this.maximized;
  }
}
</script>
<style lang="scss">
@import '@/agiles/components/style.scss';
.cx_listEditor2 {
  
  @include cx_dialog_spmode;

  .cx_list_dialog_outer{
    padding: 5px 20px;

    .cx_spmode & {
      padding: 5px 0px;
    }
  }
  .cx_list_header{
    max-width: 800px;
    // height: 400px;
    overflow-x:hidden;
    // white-space: nowrap;
    border: 1px solid lightgray;
    border-bottom: none;

    background: -webkit-linear-gradient(top, #eee 0%, #e0e0e0);
    background: -moz-linear-gradient(top, #eee 0%, #e0e0e0);
    background: -ms-linear-gradient(top, #eee 0%, #e0e0e0);
    background: -o-linear-gradient(top, #eee 0%, #e0e0e0);
    background: linear-gradient(top, #eee 0%, #e0e0e0);
    background: #e7e7e7;
    background: -webkit-gradient(linear, left top, left bottom, from(#eee), to(#e0e0e0));    

    //Gridと干渉
    .header_cell {
      height: 20px;
      font-size: 14px;
      padding-left: 10px;

      &.start {
        border-right: 1px solid #ccc;
      }
      &.center {
        border-left: 1px solid #fff;
        border-right: 1px solid #ccc;
      }
      &.end {
        border-left: 1px solid #fff;
      }
    }
  }
  .cx_list_container{
    max-width: 800px;
    max-height: 300px;
    // height: 400px;
    overflow-x:auto;
    // white-space: nowrap;
    border: 1px solid lightgray;
    border-top:none;
    margin-bottom: 10px;

    table{
      border-top:none;
    }
  }
  .button {
    // font-size: 14px;
    // height: 28px;

    // padding-top: 2px;
    // margin-top: -3px;
    outline: 0 !important;
    margin-left:10px;
    box-shadow: none;
    i {
      font-size: 22px;
    }
  }
  .button_remove {
    width: 30px;
    color: #666666;
    &:hover {
      color: #242020;
    }
    i {
      font-size: 22px;
    }
  }
  .add_div {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .cx_list_dialog_row{
    // border-bottom : 1px solid lightgray;
  }
  .cx_margin_row{
    height: 12px;
  }
  .control_cell {
    padding-top: 4px;
    padding-left: 2px;
    padding-right:2px;

    .cx_control_input{
      min-width: unset;
      .cx_control_input_read{        
        padding-left : 10px;
      }

    }

    &.end{
      padding-right:15px;
    }
  }

  .cx_grid{
      .cx_card_item {
        padding-left: 10px;
        padding-right:5px;        
      }
  }
  .remove_cell {
    display: block;
    //padding-top: 10px;
    //padding-right: 10px;
    padding-left: 5px;

    .remove_div{
      height:36px;
      display:flex;
      // padding-top:2px;
      flex-direction: column;
      justify-content:start;
    }    
  }
  table {
    //在庫振替で線が二重化しているのでコメント
    // border-top: 1px solid #ccc;
    .rowHighlight {
      background-color: #cae5e9;
    }
  }
  th {
    display: table-cell;
    border-bottom: 1px solid #ccc;

    border-top: 1px solid #fff;
    height: 30px;
    vertical-align: middle;

    text-align: left;
    overflow: hidden;
    padding: 0;
    background: -webkit-linear-gradient(top, #eee 0%, #e0e0e0);
    background: -moz-linear-gradient(top, #eee 0%, #e0e0e0);
    background: -ms-linear-gradient(top, #eee 0%, #e0e0e0);
    background: -o-linear-gradient(top, #eee 0%, #e0e0e0);
    background: linear-gradient(top, #eee 0%, #e0e0e0);
    background: #e7e7e7;
    background: -webkit-gradient(linear, left top, left bottom, from(#eee), to(#e0e0e0));
  }
  .modal-dialog {
    position: relative;
    //tooltipが見切れるためoverflowを移動
    // overflow-y: auto;
    // overflow-x: auto;
    width: fit-content;
    min-width: 300px;
    max-width: none;

    //tooltipが見切れるためoverflowを移動 ⇒ カレンダーが上手く表示されないためコメントアウト
    .modal-body {
      max-height: calc(100vh * 0.8 - 134px);
      overflow-y: auto;
    }
  }

  .maximize {
    padding: 17px 16px 16px 16px;
    margin: -1rem -0 -1rem auto;
    box-shadow: none;
    outline: none;
    border: unset;
    background-color: white;    
    opacity: 0.5;
    &:hover {
      opacity: 0.75;
    }
  }
  &.cx_modal_maximized  {
    .modal-dialog {
      margin: 0px;      
      height:var(--vh);      
      max-width: unset !important;
      .modal-content{
        height:var(--vh);  //アドレスバーの高さ分誤差が出るのでJavaScriptで計算      
        width: 100vw; //device-width        
      }
      .modal-body{
        overflow-y:auto;
        max-height: unset;
      }
      .modal-footer{
        padding-right :100px;        
      }
      .cx_editPanel_left,
      .cx_editPanel_right {
          padding-left: 10px;
          padding-right: 10px;        
          min-width: 345px;  //iphone          
      }    

      .cx_list_dialog_outer{
        display: flex;
        flex-direction: column;
        min-height: 100%;

        .cx_list_container{
          max-height: unset;
        }

        .cx_grid{
          width:100% !important; //在庫振替
        }
      }
    }
  }    
  .cx_modal_footer_button_container{
    flex: 1;
    display: flex;
  }
}
</style>
